import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  // Admin sidebar is always expanded — this controller is a placeholder
  // for future collapse/expand functionality if needed.
  connect() {}
}
